// extracted by mini-css-extract-plugin
module.exports = {"section":"ThePreloader_section_Bt_dY","bounce":"ThePreloader_bounce_p0rwX","circle":"ThePreloader_circle_1QHwq","preloader":"ThePreloader_preloader_gqJeJ"};